var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.059,
    height: 17.912,
    viewBox: "0 0 16.059 17.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M20.378,12.8l-1.672-1.672V8.912a6.185,6.185,0,0,0-5.559-6.145V1.5H11.912V2.766A6.185,6.185,0,0,0,6.353,8.912v2.215L4.681,12.8a.618.618,0,0,0-.181.437v1.853a.618.618,0,0,0,.618.618H9.441v.48A3.182,3.182,0,0,0,12.22,19.4a3.092,3.092,0,0,0,3.4-3.073v-.618h4.323a.618.618,0,0,0,.618-.618V13.235a.618.618,0,0,0-.181-.437Zm-6,3.525a1.853,1.853,0,1,1-3.706,0v-.618h3.706Zm4.941-1.853H5.735v-.98l1.672-1.672a.618.618,0,0,0,.181-.437V8.912a4.941,4.941,0,1,1,9.882,0v2.471a.618.618,0,0,0,.181.437l1.672,1.672Z",
    fill: "#3c0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhite);
export default __webpack_public_path__ + "static/media/notification-white.198d9151fd418a327c09fe14361a9ade.svg";
export { ForwardRef as ReactComponent };